import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-six-projects',
  templateUrl: './section-six-projects.component.html'
})
export class SectionSixProjectsComponent implements OnInit {

  titleSectionProp: any = {
    class: 'text-center',
    title: 'OUR PROJECTS',
    subTitle: 'Projects in Different Domain of Industry'
  };
  navigation: boolean = true;
  List: any[] = [
    // {
    //   title: 'UK Cloud',
    //   subtitle: '.',
    //   image: './assets/images/partners/1.png'
    // },
    // {
    //   title: 'JetStream',
    //   subtitle:"https://www.tradingview.com/chart/6AfSgpbI/?symbol=CME_MINI%3ANQ1%21",
    //   image: './assets/images/partners/3.png'
    // },
    // {
    //   title: 'British Telecom',
    //   subtitle: '.',
    //   image: './assets/images/partners/4.png'
    // },
    // {
    //   title: 'Working Group Two',
    //   subtitle: '.',
    //   image: './assets/images/partners/2.png'
    // },
    {
      image: './assets/images/partners/packetfabric-massedcompute.png',
      name:  'PacketFabric / Massed Compute',
      title: 'Press',
      info: 'PacketFabric and Massed Compute Introduce Industry’s First Integrated GPUaaS + NaaS Offering for Enterprise AI',
      subtitle: "https://www.prnewswire.com/news-releases/packetfabric-and-massed-compute-introduce-industrys-first-integrated-gpuaas--naas-offering-for-enterprise-ai-302663970.html"
    },
    {
      image: './assets/images/partners/p.png',
      name:  'PacketFabric.ai',
      title: 'Press',
      info: 'PacketFabric launches the first AI native Network as a Service platform enabling instant natural language pricing and provisioning',
      subtitle: "https://www.prnewswire.com/news-releases/packetfabric-launches-the-first-ai-native-network-as-a-service-platform-enabling-instant-natural-language-pricing-and-provisioning-302628286.html"
    },
   
    {
      image: './assets/images/logo.png',
      name:  'Cimcon Lighting',
      // time: 'September 26, 2019 ',
      title: 'Press',
      info: 'Digital Alpha Announces Closing of Second Digital Infrastructure Fund at Over $1 Billion',
// info2:'Platform provider aims to lower smart city set-up costs',
      subtitle: "https://www.prnewswire.com/news-releases/digital-alpha-announces-closing-of-second-digital-infrastructure-fund-at-over-1-billion-301272788.html",
      // desc: 'They bring to you a host of beautifully created infographics that contain the latest digital marketing.',
      // subtitle2:"https://www.smartcitiesworld.net/news/news/platform-provider-aims-to-lower-smart-city-set-up-costs-4566"
    },
    {
      image: './assets/images/logo.png',
      name:  'Cimcon Lighting',
      // time: 'September 26, 2019 ',
      title: 'Press',
      info: 'Roundtable discussion: Navigating digital, infrastructures hottest sector',
// info2:'Platform provider aims to lower smart city set-up costs',
      subtitle: "https://www.infrastructureinvestor.com/roundtable-navigating-digital-infras-hottest-sector/",
      // desc: 'They bring to you a host of beautifully created infographics that contain the latest digital marketing.',
      // subtitle2:"https://www.smartcitiesworld.net/news/news/platform-provider-aims-to-lower-smart-city-set-up-costs-4566"
    },
    {
      image: './assets/images/partners/star.png',
      name:  'Starlite Media',
      title: 'Press',
      info: 'Quantela Digital Alpha and Starlite Media form a 50 million strategic partnership to revolutionize retail media networks',
      subtitle: "https://www.prnewswire.com/news-releases/quantela-digital-alpha-and-starlite-media-form-a-50-million-strategic-partnership-to-revolutionize-retail-media-networks-301778893.html"
    },
    {
      image: './assets/images/partners/1.png',
      name:  'Cisco / Qwilt / Digital Alpha',
      title: 'Press',
      info: 'Cisco, Qwilt and Digital Alpha Define the Future of Content Delivery with New Open Caching Solution for Service Providers',
      subtitle: "https://newsroom.cisco.com/c/r/newsroom/en/us/a/y2020/m10/cisco-qwilt-and-digital-alpha-define-the-future-of-content-delivery-with-new-open-caching-solution-for-service-providers.html"
    },
    {
      image: './assets/images/partners/27.png',
      name:  'Cisco / Qwilt / Digital Alpha',
      title: 'Press',
      info: 'Cisco, Qwilt and Digital Alpha bring open caching to Brazil via Tim partnership',
      subtitle: "https://www.fiercevideo.com/tech/cisco-qwilt-and-digital-alpha-bring-open-caching-to-brazil-via-tim-partnership"
    },
    {
      image: './assets/images/partners/26.png',
      name:  'Cisco / Qwilt / Digital Alpha',
      title: 'Press',
      info: 'Cisco, Qwilt and Digital Alpha launching cdn solution to improve streaming experience for its customers in Argentina',
      info2: 'Sharecare and Falcon Capital Acquisition Corp. Reach Agreement to Combine, Creating Publicly Traded Digital Health Company',
      subtitle: "https://www.qwilt.com/telecom-argentina-launching-new-cisco-qwilt-and-digital-alpha-cdn-solution-to-improve-streaming-experience-for-its-customers-in-argentina/",
      subtitle2: "https://www.prnewswire.com/news-releases/sharecare-and-falcon-capital-acquisition-corp-reach-agreement-to-combine-creating-publicly-traded-digital-health-company-301227530.html"
    },
    {
      image: './assets/images/partners/9.png',
      name:  'Cisco / Qwilt / Digital Alpha',
      title: 'Press',
      info: 'Cisco, Qwilt and Digital Alpha Define the Future of Content Delivery with New Open Caching Solution for Service Providers',
      info2: 'Qwilt Content Delivery Sharing for Publishers Transforms Media Delivery',
      subtitle: "https://www.qwilt.com/cisco-qwilt-and-digital-alpha-define-the-future-of-content-delivery-with-new-open-caching-solution-for-service-providers/",
      subtitle2: "https://www.qwilt.com/qwilt-content-delivery-sharing-for-publishers-transforms-media-delivery/"
    },
    {
      image: './assets/images/partners/g.jpg',
      name:  'Google Station',
      title: 'Press',
      info: 'Google Station announcement at Mobile World Congress Barcelona',
      subtitle: "https://www.qwilt.com/telecom-argentina-launching-new-cisco-qwilt-and-digital-alpha-cdn-solution-to-improve-streaming-experience-for-its-customers-in-argentina/"
    },
    {
      image: './assets/images/partners/5.png',
      name:  'Sharecare',
      title: 'Press',
      info: 'Sharecare and Digital Alpha announce a strategic collaboration',
      subtitle: "https://www.prnewswire.com/news-releases/sharecare-and-digital-alpha-announce-a-strategic-collaboration-to-strengthen-the-nexus-of-healthcare-and-digital-infrastructure-across-america-301231713.html"
    },



  ]
  constructor() { }

  ngOnInit() {
  }

}

